import { http } from './config'

export default {

  getAllLoadProducts: () => {
    return http.get('load_products')
  },

  getAllAgroupedLoadProducts: () => {
    return http.get('agrouped_load_products')
  },

  getAllLoadDivergences: () => {
    return http.get('load_products')
  },

  getLoadProductsByLoadID: (loadID) => {
    return http.get('load_products/?load_id=' + loadID)
  },

  getAgroupedLoadProductsByLoadID: (loadID) => {
    return http.get('agrouped_load_products/?load_id=' + loadID)
  },

  createLoadProduct: (loadProductParams) => {
    return http.post('load_products', {
      load_id: loadProductParams.loadID,
      delivery_sequence: loadProductParams.deliverySequence,
      client_id: loadProductParams.client.id,
      product_id: loadProductParams.product.id,
      quantity: loadProductParams.quantity,
      box: loadProductParams.box,
    })
  },

  removeLoadProduct: (loadProductID) => {
    return http.delete('load_products/' + loadProductID)
  },

  removeAgroupedLoadProduct: (agroupedLoadProductID) => {
    return http.delete('agrouped_load_products/' + agroupedLoadProductID)
  },

  getlLoadProductsGroupedByLoadId: (loadId) => {
    return http.get('load_products/products_grouped/' + loadId)
  },

  exportLoadProductReport: (loadId) => {
    return http.get('load_products/export_load_products/' + loadId)
  },

}
